import { render } from "./InspecaoValores.vue?vue&type=template&id=5716378c&scoped=true&ts=true"
import script from "./InspecaoValores.vue?vue&type=script&lang=ts"
export * from "./InspecaoValores.vue?vue&type=script&lang=ts"

import "./InspecaoValores.vue?vue&type=style&index=0&id=5716378c&scoped=true&lang=css"

import exportComponent from "D:\\RopeSeguros\\FrontEnd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5716378c"]])

export default __exports__